module.exports = __webpack_public_path__ + "files/617ee0b1f839b27bcdfaf6c7731fe0ed.png";